export class AddTypeBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  statusLid: string;
  statusLovName: string;
  typeName: string;
}
export class GetListBasetype {
  statusLid: string | null;
  SearchColumn: string = "typeName";
  SearchText: string = "";
  orderColumn: string = "typeName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  field: string = "typeName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith"
  type: string = "string";
}
export class WhereCondition {
  field: string = "typeName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
// ...........................................notes.........................................................................

export class AddNoteBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  date: string;
  notes: string;
  noteTypeIds: string[];
  noteTypeId: string = "00000000-0000-0000-0000-000000000000";
  clientId: string = "00000000-0000-0000-0000-000000000000";
  agencyId: string = "00000000-0000-0000-0000-000000000000";
  user: string
  multipletype: [];
}

export class GetListBasenote {
  SearchColumn: string = "noteTypeName";
  SearchText: string = "";
  orderColumn: string = "noteTypeName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: string = "00000000-0000-0000-0000-000000000000";
  field: string = "noteTypeName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  type: string = "string";
  startDate: string | null;
  endDate: string | null;
  noteTypeId: string = "00000000-0000-0000-0000-000000000000";
  clientId: string;
}
export class WhereConditionnote {
  field: string = "noteTypeName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
